'use client';

import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

const elements = [
  { num: 1, title: 'Trust Signals Above the Fold', impact: 'High', detail: 'Reviews, ratings, NMLS#, licensing — visible without scrolling', color: '#ff34a7' },
  { num: 2, title: 'Clear Value Proposition', impact: 'Critical', detail: "What you do, who you help, why you're different — in one sentence", color: '#ff34a7' },
  { num: 3, title: 'Rate/Quote Tool or Calculator', impact: 'Critical', detail: 'Interactive engagement > static forms. Calculators convert 2-4x better', color: '#ff34a7' },
  { num: 4, title: 'Multi-Step Form (Not Single)', impact: 'High', detail: 'Start with easy questions, build commitment. 15-25% lift over single forms', color: '#294bfd' },
  { num: 5, title: 'Mobile-First Design', impact: 'Critical', detail: "70%+ of mortgage traffic is mobile. If it doesn't work on phones, it doesn't work", color: '#294bfd' },
  { num: 6, title: 'Social Proof / Testimonials', impact: 'High', detail: 'Video testimonials > written. Recent > old. Specific results > vague praise', color: '#294bfd' },
  { num: 7, title: 'Speed (Under 3 Seconds)', impact: 'Critical', detail: 'Every second of load time costs 7% conversion. Core Web Vitals matter', color: '#10b981' },
  { num: 8, title: 'Local Content / Area Pages', impact: 'Medium', detail: 'City-specific pages capture "mortgage lender in [city]" searches', color: '#10b981' },
  { num: 9, title: 'Blog / Educational Content', impact: 'Medium', detail: 'Builds authority, captures informational searches, nurtures top-of-funnel', color: '#10b981' },
  { num: 10, title: 'Clear CTAs on Every Page', impact: 'High', detail: 'Every page needs a next step. No dead ends. Phone, form, chat — always available', color: '#ff34a7' },
];

export function WebsiteAnatomy() {
  return (
    <ShareableChart title="10 Elements of a High-Converting Mortgage Website">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        Anatomy of a High-Converting Mortgage Website
      </h3>
      <p className="text-sm text-gray-500 mb-4" style={{ fontFamily: FONT_TEXT }}>
        10 elements that separate sites converting under 1% of visitors from sites converting 5-15%
      </p>

      <div className="space-y-2">
        {elements.map((el) => (
          <div key={el.num} className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
              style={{ backgroundColor: el.color, fontFamily: FONT_TEXT }}
            >
              {el.num}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-sm text-gray-900" style={{ fontFamily: FONT_TEXT }}>{el.title}</span>
                <span 
                  className="text-xs px-2 py-0.5 rounded-full font-medium"
                  style={{ 
                    backgroundColor: el.impact === 'Critical' ? '#fff5fb' : el.impact === 'High' ? '#f0f4ff' : '#f0fdf4',
                    color: el.impact === 'Critical' ? '#ff34a7' : el.impact === 'High' ? '#294bfd' : '#10b981',
                    fontFamily: FONT_TEXT
                  }}
                >
                  {el.impact}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-0.5" style={{ fontFamily: FONT_TEXT }}>{el.detail}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-4" style={{ fontFamily: FONT_TEXT }}>
        Source: leadpops.com · Based on 15+ years optimizing mortgage websites and 3.2M+ leads generated
      </p>
    </ShareableChart>
  );
}
